import { useIntl } from 'react-intl';
import { IconSchool, IconSchoolOff } from '@rossum/ui/icons/tabler';
import { SvgIcon, Switch, Tooltip } from '@rossum/ui/material';
import {
  SidebarItemLabel,
  SidebarItemLayout,
} from '../../../../document-sidebar';

type TrainingToggleProps = {
  checked: boolean;
  disabled: boolean;
  isLoading: boolean;
  onChange: (checked: boolean) => void;
};

export const TrainingToggle = ({
  checked,
  disabled,
  isLoading,
  onChange,
}: TrainingToggleProps) => {
  const intl = useIntl();

  const tooltipText = intl.formatMessage({
    id: checked
      ? 'components.sidebarV2.annotationData.trainingToggle.tooltip.enabled'
      : 'components.sidebarV2.annotationData.trainingToggle.tooltip.disabled',
  });

  return (
    <SidebarItemLayout
      iconSlot={
        <Tooltip title={tooltipText} placement="top">
          <SvgIcon
            fontSize="medium"
            sx={{
              display: 'block',
            }}
          >
            {checked ? <IconSchool /> : <IconSchoolOff />}
          </SvgIcon>
        </Tooltip>
      }
      labelSlot={
        <SidebarItemLabel
          label={intl.formatMessage({
            id: 'components.sidebarV2.annotationData.labels.includedInTraining',
          })}
        />
      }
      valueSlot={
        <Switch
          checked={checked}
          disabled={disabled}
          onChange={(_e, value) => (isLoading ? null : onChange(value))}
          data-cy="annotation-sidebar-toggle-training"
        />
      }
    />
  );
};
